const { parseSelectedFilters } = require('../../analyticUtils');
const { analyticsEventCenter, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const { createEcommerceEventGA4 } = require('../models/ecommerceEventGA4');
const { createEcommerceEventItemsGA4 } = require('../models/ecommerceEventItemsGA4');
const pushEvent = require('../pushEvent');
const { default: getFrontConfig } = require('../../../common/getFrontConfig');
const positionUtils = require('../utils/positionUtils');
const { getItemListForProductID } = require('../../stores/itemList');

const {
  vue: { TheProductList: { columnMode } },
} = getFrontConfig();

/* -------------------------------------------------------------------------- *\
 * PLP EVENTS                                                                 *
 * ----------                                                                 *
 * - Banner image                                                             *
 * - Carousel                                                                 *
 * - Column mode                                                              *
 * - Filters                                                                  *
 * - Viewed                                                                   *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  // Banner image
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.productListBannerClicked,
    (payload) => pushEvent(
      createCustomEventGA4('grid_banner_click', [
        ['type', payload.type],
      ]),
    ),
  );
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.productListBannerViewed,
    (payload) => pushEvent(
      createCustomEventGA4('grid_banner_impression', [
        ['type', payload.type],
      ]),
    ),
  );

  // Carousel
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.productListBannerCarouselProductClicked,
    (payload) => pushEvent(
      createCustomEventGA4('grid_carousel_click', [
        ['action', 'click'],
        ['position', positionUtils.oneBasedPosition(payload.position)],
      ]),
    ),
  );
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.productListBannerCarouselViewed,
    (payload) => pushEvent(
      createCustomEventGA4('grid_carousel_impression', [
        ['action', 'impression'],
        ['position', positionUtils.oneBasedPosition(payload.position)],
      ]),
    ),
  );

  // Column mode
  const t = ANALYTICS_EVENTS.PAYLOADS.productListColumnModeClicked.columnMode;
  const typeToLabelMap = {
    [columnMode.compressed]: t.compressedView,
    [columnMode.default]: t.defaultView,
  };
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.productListColumnModeClicked,
    (type) => pushEvent(
      createCustomEventGA4(typeToLabelMap[type], [
        ['action', 'click'],
      ]),
    ),
  );

  // Filters
  analyticsEventCenter.subscribe(
    [
      ANALYTICS_EVENTS.productListFiltersApplied,
      ANALYTICS_EVENTS.productListFiltersReset,
    ],
    (payload) => pushEvent(
      createCustomEventGA4('grid_filters', [
        ['action', 'apply'],
        ['item', parseSelectedFilters(payload)],
      ]),
    ),
  );
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.productListFiltersClosed,
    () => pushEvent(
      createCustomEventGA4('grid_filters', [
        ['action', 'close'],
      ]),
    ),
  );
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.productListFiltersOpened,
    () => pushEvent(
      createCustomEventGA4('grid_filters', [
        ['action', 'open'],
      ]),
    ),
  );
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.productListViewedEmpty,
    ({ category }) => pushEvent(
      createCustomEventGA4('grid_empty', [
        ['item', category.name],
        ['url', category.url],
      ]),
    ),
  );

  // Viewed
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.productListViewed, (payload) => {
      const productsData = payload.products.map((product, index) => ({
        ...product.product,
        itemProps: {
          index: positionUtils.oneBasedPosition(index),
          item_list_id: payload.list || getItemListForProductID(product.id),
          product_id_with_size: undefined,
          searched_term: payload.searched_term || undefined,
        },
      }));
      pushEvent(
        createEcommerceEventGA4('view_item_list', createEcommerceEventItemsGA4(productsData)),
      );
    }
  );
}

module.exports = {
  subscribeToAnalyticsEvents,
};
